import { ax } from "api/axios";

export const fetchLogin = (email: string, password: string) => {
  return ax.patch("/auth/login", { email, password });
};

export const fetchLogout = () => {
  return ax.patch("/auth/logout");
};
